import "babel-polyfill";
// import "semantic-ui-less/semantic.less";
import "./semantic-ui/semantic.less";
import "./styles/site.less";
import "./styles/react-table.less";
import 'react-querybuilder/dist/query-builder.css';
import "react-datepicker/dist/react-datepicker.css";
import { PageState } from "@app/services";
import { ClientResources } from "@app/api2/api";
// import './index.css'

var state: PageState;

declare global {
    interface Window {
        pageState: PageState;
        translation: ClientResources;
        locale: string;
    }
}

window.onload = (ev) => {
    state = new PageState(null);
};

// if (module.hot) {
//     module.hot.accept("./services",
//         () => {
//             // ReSharper disable once CommonJsExternalModule
//             // This pokes at Webpack's HMR
//             const newServices = require("./services") as any;
//             state = new newServices.PageState(state);
//         });
// }
